import { useMemo } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { NetworkStatus } from '@apollo/client';

import { productDetails } from '@legacyUrls';
import { ProductDetailsPosts } from '@components/ProductDetailsPosts';

import { useProductDetailsPostsQuery } from './gql/graphql.v5.generated';

interface Props {
  className?: string,
}

export const ProductDetailsPostsContainer: React.FC<Props> = ({
  className,
}) => {
  const match = useRouteMatch<{ productId: string }>(productDetails);

  const productId = match?.params.productId;

  const { data, loading, fetchMore, networkStatus } = useProductDetailsPostsQuery({
    context: {
      v5: true,
      batch: true,
    },
    variables: {
      productId: productId as string,
    },
    notifyOnNetworkStatusChange: true,
    skip: !productId,
  });

  const handleLoadMore = async () => {
    if (data?.postsByProduct?.pageInfo.hasNextPage) {
      await fetchMore({
        variables: {
          after: data?.postsByProduct?.pageInfo.endCursor,
        },
      });
    }
  };

  const posts = useMemo(() => (
    data?.postsByProduct.edges
      .map(({ node }) => node)
      .filter((post) => post.mediasUrls.length)  || []
  ), [data?.postsByProduct]);

  // don't show skeletons during loading state for improving CLS at desktop
  if (productId && posts.length) {
    return (
      <ProductDetailsPosts
        className={className}
        posts={posts}
        productId={productId}
        loading={loading}
        fetching={networkStatus === NetworkStatus.fetchMore}
        hasNextPage={!!data?.postsByProduct?.pageInfo.hasNextPage}
        onLoadMore={handleLoadMore}
      />
    );
  }

  return null;
};
